export default __webpack_public_path__ + "static/media/arrow_bottom.e50f9c90.svg";